/**
 * The choices for "Možnosť zrušenia klientom" on a service, a manual reservation and an event: minutes before the
 * start (`cancellationDeadlineField`). `0` ends at the start - nobody cancels what is already under way.
 */
export const CANCELLATION_DEADLINE_OPTIONS: readonly { value: number; label: string }[] = [
  { value: -1, label: 'Klient nemôže zrušiť sám' },
  { value: 0, label: 'Kedykoľvek do začiatku' },
  { value: 60, label: '1 hodinu pred začiatkom' },
  { value: 1440, label: '24 hodín pred začiatkom' },
]
